/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElInput as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElDivider as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/divider/style/css';
import { ElSelect as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex marginB10"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "选择渠道：", -1);
const _hoisted_3 = {
  style: {
    "line-height": "25px"
  }
};
const _hoisted_4 = {
  class: "flex items-center"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "dialog-footer"
};
import UUpload from '@ultra/share/components/UUpload/index.vue';
import { fnGetExtension, getXmlJson, dataURLtoFile } from '@/utils/util';
import getFileMD5 from '@/utils/getFileMD5';
import { apiUsdkParseOfficialPackage, apiUsdkAddOfficialPackage } from '@/api/usdk';
import ultraUploadFile from '@ultra/share/utils/ultraUpload.js';
export default /*#__PURE__*/_defineComponent({
  __name: 'uploadPack',
  props: {
    gameInfo: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['ok'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    const AppInfoParser = require('hero-app-info-parser');
    const fileList = ref([]);
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const packageInfos = ref([]);
    const remark = ref('');
    const form = ref({});
    const channelId = ref();
    const handleChangeChannel = (val, index) => {
      let info = packageInfos.value[index].GameInfo.find(item => item.cid === val);
      let dict = {
        GameName: info.gameName,
        ChannelName: info.channelName,
        ChannelId: info.cid,
        GameId: info.gid
      };
      for (let key in dict) {
        packageInfos.value[index][key] = dict[key];
      }
    };
    const beforeUpload = async file => {
      let index = 0;
      let res = await new AppInfoParser(file).parse().then(async ret => {
        console.log('ret', ret);
        let isIos = fnGetExtension(file)[1] === 'ipa';
        let dict = {
          File: file,
          FileSize: file.size,
          PackageInfo: ret,
          SdkVersion: ret.SdkVersion,
          PackageName: ret.package || ret.CFBundleIdentifier,
          Version: ret.versionName || ret.CFBundleShortVersionString,
          VersionCode: ret.versionCode || ret.CFBundleVersion || 0,
          AppName: ret.CFBundleDisplayName,
          EncodeStr: ret.SdkConfKey,
          XmlJson: getXmlJson(ret)
        };
        packageInfos.value.push({
          ...dict
        });
        try {
          packageInfos.value.map((item, i) => {
            if (item.File.uid === file.uid) {
              index = i;
              if (Array.isArray(ret.application.label)) {
                item.AppName = ret.application.label[0];
              } else {
                item.AppName = ret.application.label;
              }
            }
          });
        } catch (error) {
          console.log('error', error);
        }
        const result = await getGameInfoByPackage(packageInfos.value[index], isIos, index);
        return result;
      });
      if (!res) {
        deleteFile('', index);
      }
      return res;
    };
    const handleRemove = file => {
      packageInfos.value.map((item, index) => {
        if (item.File.uid === file.uid) {
          packageInfos.value.splice(index, 1);
        }
      });
    };
    // 获取包关联的游戏信息
    const getGameInfoByPackage = async (item, isIos, index) => {
      const md5 = await getFileMD5(item.File);
      packageInfos.value[index].Md5 = md5;
      const result = await apiUsdkParseOfficialPackage({
        pkgName: item.PackageName
      });
      if (result.code === 0) {
        let gameList = result.data.filter(g => g.gid == props.gameInfo.Id);
        packageInfos.value[index].GameInfo = gameList;
        if (gameList.length === 1) {
          packageInfos.value[index].GameName = gameList[0].gameName;
          packageInfos.value[index].ChannelName = gameList[0].channelName;
          packageInfos.value[index].GameId = gameList[0].gid;
          if (item.GameInfo[0].ChannelId) {
            packageInfos.value[index].ChannelId = gameList[0].cid;
          }
        }
        packageInfos.value[index].isUpload = true;
        uploadPackageIcon(packageInfos.value[index], index);
        return true;
      } else {
        ElMessage({
          message: result.msg,
          type: 'error'
        });
        deleteFile('', index);
        return false;
      }
    };
    // 上传文件icon
    const uploadPackageIcon = async (item, index) => {
      const baseUrl = item.PackageInfo.icon;
      if (baseUrl) {
        const iconFile = dataURLtoFile(baseUrl, new Date().getTime() + '.png');
        const params = {
          file: iconFile
        };
        await ultraUploadFile({
          params
        }).then(async res => {
          packageInfos.value[index].Icon = res.url;
        });
      }
    };
    const handleFileComplete = (file, url) => {
      packageInfos.value.map(item => {
        if (item.File.uid === file.uid) {
          item.Url = url;
          item.isUpload = false;
        }
      });
    };
    const deleteFile = (file, index) => {
      packageInfos.value.splice(index, 1);
    };
    const handleSubmit = () => {
      if (!packageInfos.value.length) {
        ElMessage.warning('请上传渠道包!');
        return;
      }
      let isNotCid = packageInfos.value.some(item => !item.ChannelId);
      if (isNotCid) {
        ElMessage.warning('请选择渠道!');
        return;
      }
      confirmLoading.value = true;
      const submitPromises = [];
      console.log('packageInfos===>', packageInfos.value);
      let flag = false;
      packageInfos.value.forEach(item => {
        let params = {
          pkgName: item.PackageName,
          gid: item.GameId,
          cid: item.ChannelId,
          icon: item.Icon,
          pkgUrl: item.Url,
          md5: item.Md5,
          verName: item.Version,
          sdkResourceName: item.SdkVersion,
          sdkResourceId: -1,
          verCode: item.VersionCode,
          remark: remark.value,
          fileSize: item.FileSize // fileSize
        };

        if (!item.Url) {
          flag = true;
          return;
        }
        let request = apiUsdkAddOfficialPackage(params);
        submitPromises.push(request);
      });
      if (flag) {
        ElMessage.warning('官方包正在上传中！');
        confirmLoading.value = false;
        return;
      }
      Promise.all(submitPromises).then(res => {
        // _this.$emit('close');
        // _this.$emit('ok');
        emits('ok');
        console.log('res', res);
      }).finally(() => {
        confirmLoading.value = false;
        handleClose();
      });
    };
    const handleClose = () => {
      dialogVisible.value = false;
      packageInfos.value = [];
      remark.value = '';
      form.value = {};
      channelId.value = '';
    };
    watch(packageInfos.value, val => {
      console.log('object', val);
    });
    const show = () => {
      fileList.value = [];
      dialogVisible.value = true;
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_option = __unplugin_components_1;
      const _component_el_select = __unplugin_components_2;
      const _component_el_divider = __unplugin_components_3;
      const _component_el_input = __unplugin_components_4;
      const _component_el_form = __unplugin_components_5;
      const _component_el_button = __unplugin_components_6;
      const _component_el_dialog = __unplugin_components_7;
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "上传渠道包",
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        width: "600px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(confirmLoading),
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(form),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "上传渠道包"
          }, {
            default: _withCtx(() => [_createVNode(UUpload, {
              modelValue: _unref(fileList),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(fileList) ? fileList.value = $event : null),
              multiPart: "",
              accept: ".apk,.aab,.ipa",
              beforeUpload: beforeUpload,
              onRemove: handleRemove,
              onCompleteFile: handleFileComplete
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _unref(packageInfos).length ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "包体信息"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packageInfos), (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, [item.GameInfo && item.GameInfo.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_select, {
                modelValue: _unref(channelId),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(channelId) ? channelId.value = $event : null),
                class: "width200px",
                placeholder: "选择渠道",
                onChange: $event => handleChangeChannel($event, index)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.GameInfo, item2 => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    value: item2.cid,
                    key: item2.cid,
                    label: item2.channelName
                  }, null, 8, ["value", "label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onChange"])])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_3, [_createElementVNode("li", _hoisted_4, [_createTextVNode("ICON： "), _createElementVNode("img", {
                style: {
                  "width": "50px"
                },
                src: item.Icon,
                alt: ""
              }, null, 8, _hoisted_5)]), _createElementVNode("li", null, "游戏名: " + _toDisplayString(item.GameName), 1), _createElementVNode("li", null, "渠道名: " + _toDisplayString(item.ChannelName), 1), _createElementVNode("li", null, "MD5: " + _toDisplayString(item.Md5), 1), _createElementVNode("li", null, "包名: " + _toDisplayString(item.PackageName), 1), _createElementVNode("li", null, "版本号: " + _toDisplayString(item.Version), 1), _createElementVNode("li", null, "VersionCode: " + _toDisplayString(item.VersionCode), 1), _createElementVNode("li", null, "Sdk: " + _toDisplayString(item.SdkVersion), 1), _createVNode(_component_el_divider)])]);
            }), 128))])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(remark),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(remark) ? remark.value = $event : null),
              placeholder: "填写备注"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});